module.exports = __webpack_public_path__ + "media/MRI10B.4533a7d3.mp3";